/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React, { Component } from 'react';
import {
    object, string, func, shape, arrayOf,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import CgcEditor from '../../RTE/CgcEditor';

const styles = () => ({
    messageContent: {
        width: '100%',
        height: '100%',
        boxSizing: 'border-box',
        resize: 'none',
        padding: '15px 5px',
        border: 'none',
    },
    textEditor: {
        position: 'absolute',
        right: 10,
        top: 150,
        zIndex: 1000,
    },
    messageWrapper: {
        width: '100%',
        height: '100%',
        padding: 5,

    },
});
class CustomsMessageView extends Component {
    constructor(props) {
        super(props);
        const { csLabelData, messageData } = this.props;

        let existingStyles = {};
        if (messageData?.style) {
            existingStyles = messageData.style;
        }

        this.state = {
            text: '',
            style: {
                fontSize: `${csLabelData?.message_settings?.heading_font_size}px`,
                ...existingStyles,
            },
            showTextEditor: false,
            fontLimit: null,
        };
    }

    componentDidMount() {
        const { messageData, toolbarProps } = this.props;
        const fontFamliyData = toolbarProps?.filter((item) => item?.value === 'font');
        const font = fontFamliyData?.[0]?.list?.[0];
        this.setState({ style: { fontLimit: font?.maxChar, fontFamily: messageData?.style?.fontFamily || font?.value } });
        if (messageData?.text) {
            this.setState({
                text: messageData?.text,
                style: messageData?.style,
            });
        }
    }

    handleTextEditor = (val) => {
        this.setState({ showTextEditor: val });
    }

    updateMessageData = () => {
        const { text, style } = this.state;
        const { setCardMessage } = this.props;
        const messageData = {
            style, text,
        };
        setCardMessage(messageData);
    }

    handleChange = (e) => {
        this.setState({
            text: e.target.value,
        }, () => this.updateMessageData());
    };

    handleStyle = (style) => {
        const { toolbarProps } = this.props;
        const { text } = this.state;
        const fontFamliyData = toolbarProps?.filter((item) => item?.value === 'font');
        const font = fontFamliyData?.[0]?.list?.filter((fontData) => fontData?.value === style.fontFamily);
        const controlledText = text?.substr(0, font?.[0]?.maxChar);
        this.setState({
            style, fontLimit: font?.[0]?.maxChar, text: controlledText,
        }, () => this.updateMessageData());
    }

    renderEditor = () => {
        const { classes } = this.props;
        const { style } = this.state;
        return (
            <Grid className={classes.textEditor}>
                <CgcEditor
                    style={style}
                    handleStyle={this.handleStyle}
                />
            </Grid>
        );
    }

    render() {
        const { classes } = this.props;
        const {
            text, style, showTextEditor, fontLimit,
        } = this.state;
        return (
            <>
                <Grid className={classes.messageWrapper}>
                    <textarea
                        className={classes.messageContent}
                        placeholder="Enter Text Here"
                        value={text}
                        style={style}
                        maxLength={fontLimit}
                        onChange={(e) => this.handleChange(e)}
                        onFocus={() => this.handleTextEditor(true)}
                    />
                </Grid>
                {showTextEditor
                && this.renderEditor()}

            </>
        );
    }
}
CustomsMessageView.propTypes = {
    classes: object.isRequired,
    messageData: string.isRequired,
    setCardMessage: func.isRequired,
    csLabelData: shape({
        message_settings: shape({
            heading_font_size: string,
        }),
    }).isRequired,
    toolbarProps: arrayOf(shape({
        value: string,
        label: string,
        icon: string,
        title: string,
        type: string,
        list: arrayOf(shape({
            label: string,
            value: string,
        })),
    })),
};
CustomsMessageView.defaultProps = {
    toolbarProps: {},
};
export default withStyles(styles)(CustomsMessageView);
